import { Checkbox } from "@/components/ui/checkbox";
import { useEffect } from "react";

interface Props {
  setGender: (data: any) => void;
  gender: string;
  setValidStep: (state: boolean) => void;
}

const GENDERS = ["male", "female"];

export default function GenderScreen(props: Props) {
  const { gender, setGender } = props;

  useEffect(() => {
    if (!GENDERS.includes(gender)) {
      props.setValidStep(false);
      return;
    }

    props.setValidStep(true);
  }, [gender]);

  return (
    <div className="flex flex-col max-h-[500px] h-full md:h-[calc(100vh-450px)] md:!min-h-[320px] w-full justify-center gap-2">
      <span className="text-gray-400 text-xs font-medium font-['DM Sans']">
        Cinsiyetiniz
      </span>

      <div className="flex flex-col gap-6">
        <label
          onClick={() => setGender("male")}
          className="w-full flex py-2 px-4 border border-assistant-secondary rounded-[24px] h-14 shadow cursor-pointer"
        >
          <div className="flex flex-row font-bold text-sm items-center gap-2">
            <Checkbox
              checked={gender == "male"}
              className="rounded-full w-6 h-6 duration-200"
            />
            Erkek
          </div>
        </label>

        <label
          onClick={() => setGender("female")}
          className="w-full flex py-2 px-4 border border-assistant-secondary rounded-[24px] h-14 shadow cursor-pointer"
        >
          <div className="flex flex-row font-bold text-sm items-center  gap-2">
            <Checkbox
              checked={gender == "female"}
              className="rounded-full w-6 h-6 duration-200"
            />
            Kadın
          </div>
        </label>
      </div>
    </div>
  );
}
